@if (switchService.showInTenantShell()) {
  <button
    type="button"
    class="context-pill context-pill--button"
    [class.context-pill--operated]="isOperatedTenant()"
    (click)="openPicker()"
    [attr.aria-label]="pillAriaLabel()"
    [attr.title]="operatedHint()"
  >
    <span
      class="context-pill__avatar"
      [style.background]="activeLogoUrl() ? '#ffffff' : activeBrandColor()"
    >
      @if (activeLogoUrl()) {
        <img [src]="activeLogoUrl()" alt="" (error)="onLogoError()" />
      } @else {
        <span>{{ activeInitials() }}</span>
      }
    </span>
    <span class="context-pill__label truncate">{{ switchService.activeCompany()?.name }}</span>
    @if (isOperatedTenant()) {
      <span class="context-pill__chip">{{ 'platform.operatedTenant.bannerChip' | translate }}</span>
      <span class="context-pill__operated-dot" aria-hidden="true"></span>
    }
    <i-tabler name="chevron-down" class="context-pill__chevron shrink-0"></i-tabler>
  </button>
}
